import { compose, cond, not, includes, __, converge, equals } from 'ramda';

import localizeLink from 'app/features/localization/localizeLink';
import {
  ALREADY_PREMIUM_PATH,
  UNAVAILABLE_PATH,
  CAMPAIGN,
  MIGRATION_LANDING_PATH,
} from 'app/router/constants/paths';
import {
  isUserPremium,
  userCountryCode,
  userLocale,
} from 'app/features/user/selectors';
import geoEligibleCountryCodes from 'app/features/migration/landing/constants';
import { getAppName, getPathnameWithoutLocale } from 'app/router/selectors';
import {
  couponFlowPath,
  parsedCoupon,
} from 'app/features/couponCampaign/selectors';

const isGeoIneligible = compose(
  not,
  includes(__, geoEligibleCountryCodes),
  userCountryCode,
);

const addAppName = path => compose(appName => `/${appName}${path}`, getAppName);

const selectPath = cond([
  [
    isUserPremium,
    addAppName(`${ALREADY_PREMIUM_PATH}?${CAMPAIGN}=contentmigration`),
  ],
  [isGeoIneligible, addAppName(`${UNAVAILABLE_PATH}?nextlevel=invalidcountry`)],
  [
    compose(not, parsedCoupon),
    addAppName(`${UNAVAILABLE_PATH}?nextlevel=invalidurl`),
  ],
]);

const redirectUrl = converge(localizeLink, [selectPath, userLocale]);

const isMigrationLandingPath = converge(
  (path, appName) =>
    path === `/${appName}${MIGRATION_LANDING_PATH}` ||
    path === `/${appName}${MIGRATION_LANDING_PATH}/`,
  [getPathnameWithoutLocale, getAppName],
);

const isMigrationCouponFlow = compose(
  equals(MIGRATION_LANDING_PATH),
  couponFlowPath,
);

export { redirectUrl, isMigrationLandingPath, isMigrationCouponFlow };
